import React from "react";
import "survey-core/defaultV2.css";
import * as Survey from "survey-react-ui";
import { Model } from "survey-core";
import { Card, Typography, Row, Col } from "antd";
import { useEffect } from "react";
import "./SurveyForm.css"; // For additional custom styling

const { Title } = Typography;

const SurveyForm = () => {
  // Define the survey JSON with questions
  const surveyJSON = {
    title: "Customer Feedback Survey",
    showProgressBar: "top",
    pages: [
      {
        elements: [
          {
            type: "text",
            name: "username",
            title: "Please enter your name:",
            isRequired: true,
          },
          {
            type: "radiogroup",
            name: "satisfaction",
            title: "How satisfied are you with our service?",
            choices: [
              "Very Satisfied",
              "Satisfied",
              "Neutral",
              "Dissatisfied",
              "Very Dissatisfied",
            ],
            isRequired: true,
          },
          {
            type: "comment",
            name: "suggestions",
            title: "Any suggestions for improvement?",
          },
        ],
      },
    ],
  };

  // Initialize the survey model
  const survey = new Model(surveyJSON);

  // Handle survey submission
  survey.onComplete.add((sender) => {
    console.log("Survey results:", sender.data);
    // You can also send sender.data to your backend here
  });

  return (
    <Row
      justify="center"
      className="survey"
      style={{ padding: "2rem", background: "lightgrey" }}
    >
      <Col xs={24} sm={20} md={16} lg={12}>
        <Card
          style={{
            boxShadow: "0 4px 10px rgba(0, 0, 0, 0.1)",
            borderRadius: "10px",
            padding: "2rem",
          }}
        >
          <Title level={3} style={{ textAlign: "center", color: "#1890ff" }}>
            Customer Feedback Survey
          </Title>
          <Survey.Survey model={survey} />
        </Card>
      </Col>
    </Row>
  );
};

export default SurveyForm;
